/**
 * Resolve public media stream URL for img/src and links.
 * Avoids duplicate /api when REACT_APP_API_URL (or VITE_API_URL) already ends with /api.
 *
 * @param {string} mediaAssetId - Mongo id of MediaAsset
 * @returns {string}
 */
export function resolveMediaPublicUrl(mediaAssetId) {
  if (!mediaAssetId) return ''
  const path = `/api/media/public/${mediaAssetId}`
  const base =
    (typeof import.meta !== 'undefined' && import.meta.env?.VITE_API_URL) ||
    (typeof process !== 'undefined' && process.env?.REACT_APP_API_URL) ||
    ''
  const b = base.replace(/\/$/, '')
  if (!b) return path
  if (b.endsWith('/api') && path.startsWith('/api/')) {
    return `${b}${path.replace(/^\/api/, '')}`
  }
  return `${b}${path}`
}

const NON_PUBLIC_HOSTS = new Set([
  'backend',
  'mongo',
  'redis',
  'minio',
  'postgres',
  'mysql',
  'mongodb',
  'ai_backend',
  'ai-backend',
  'nginx',
])

function apiBaseForBrowser() {
  return (
    (typeof import.meta !== 'undefined' && import.meta.env?.VITE_API_URL) ||
    (typeof process !== 'undefined' && process.env?.REACT_APP_API_URL) ||
    ''
  ).replace(/\/$/, '')
}

function joinApiBase(base, path) {
  if (!base) return path
  if (base.endsWith('/api') && path.startsWith('/api/')) {
    return `${base}${path.replace(/^\/api/, '')}`
  }
  return `${base}${path.startsWith('/') ? path : `/${path}`}`
}

/**
 * Normalize a media URL from the API (absolute or relative) for display.
 * @param {string} url
 * @returns {string}
 */
export function resolveMediaUrl(url) {
  if (!url) return url

  if (url.startsWith('http')) {
    try {
      const u = new URL(url)
      if (NON_PUBLIC_HOSTS.has(u.hostname.toLowerCase()) && u.pathname.startsWith('/api/media/public/')) {
        return joinApiBase(apiBaseForBrowser(), `${u.pathname}${u.search}`)
      }
    } catch {
      /* keep original */
    }
    return url
  }

  return joinApiBase(apiBaseForBrowser(), url)
}
